export function isDriverRequest(url = "") {
  return String(url).includes("/driver/");
}

export function isPublicAuthRequest(url = "") {
  const path = String(url).split("?")[0].toLowerCase();
  return [
    "/hosts/login",
    "/hosts/register",
    "/hosts/forgotpassword",
    "/hosts/resetpassword",
    "/hosts/verify-email",
    "/hosts/update-email-confirmation",
    "/teams/login",
    "/teams/invites/validate",
  ].some((publicPath) => path.startsWith(publicPath));
}

export function isAuthExpiredStatus(status) {
  return [401, 440].includes(Number(status));
}

export function shouldRedirectToHostLogin({ status, url }) {
  return (
    isAuthExpiredStatus(status) &&
    !isDriverRequest(url) &&
    !isPublicAuthRequest(url)
  );
}
